import { DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI } from '../../../types/default-cloud-graph-video-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';

import { GongIcon, GongSearchResultIcon } from './icon';

// Entity types are the frontend projection of the connector's PRD + design docs: Gong
// surfaces call recordings/transcripts (Video) only, no calendar events or document
// content. (Corroborated by the Alexander registration: VIDEO only.)
export const gongConfig: ThirdPartyConfig = {
	displayName: 'Gong',
	id: 'gong',
	resourceType: ProductResourceTypes3P.Gong,
	icon: get3PLogo(GongIcon, 'Gong', 'medium'),
	searchResultIcon: get3PLogo(GongSearchResultIcon, 'Gong', 'large'),
	integrationAri: 'ari:cloud:platform::integration/gong',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Video,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	filters: ['lastUpdated', 'onlyTitleMatch'],
	requiresOauth: true,
	isEnabled: () => true,
};
